import React from 'react';
//@ts-expect-error
import { RadioButton as RadioButtonRC } from '@checkout/react-components';
import type { InputOnBlurChange, ReactComponentsChangeHandler } from '@/types';

import { getCommonRadioButtonStyleOverrides } from './styles';

interface RadioButtonProps {
  blurHandler?: InputOnBlurChange;
  changeHandler: ReactComponentsChangeHandler;
  checked?: boolean;
  disabled?: boolean;
  hasError?: boolean;
  id: string;
  label: React.ReactNode;
  name: string;
  value?: string;
  [x: string]: React.ReactNode;
}

export const RadioButton = ({
  blurHandler,
  changeHandler,
  checked,
  disabled,
  hasError,
  id,
  label,
  name,
  value,
  ...rest
}: RadioButtonProps): React.ReactElement => {
  return (
    <RadioButtonRC
      {...(hasError && { 'aria-describedby': 'cardProductClass-error' })}
      aria-invalid={hasError}
      blurHandler={blurHandler}
      changeHandler={changeHandler}
      checked={checked}
      disabled={disabled}
      id={id}
      label={label}
      name={name}
      value={value}
      {...rest}
      {...getCommonRadioButtonStyleOverrides({
        disabled,
        displayError: hasError,
        ...rest,
      })}
    />
  );
};
